const ozLendingRed = '#ee1400';

const palette = {
  black: '#000000',
  grey100: '#e0e0e0',
  grey200: '#aeaeb1',
  grey300: '#7c7c81',
  grey400: '#666666',
  grey600: '#00023f',
  grey700: '#181b31',
  placeholder: ozLendingRed,
  red: ozLendingRed,
};

const colors = {
  active: palette.placeholder,
  black: palette.black,
  currentSession: palette.black,
  error: '#ee1400',
  form: palette.placeholder,
  homeAuto: palette.placeholder,
  hover: '#e12a19',
  info: '#ee1400',
  mortgage: palette.placeholder,
  primary: palette.red,
  realEstate: palette.placeholder,
  savings: palette.placeholder,
  secondary: palette.grey700,
  text: palette.grey300,
  textDarker: palette.grey400,
  transparentPrimary: palette.placeholder,
  white: '#ffffff',
};

export {
  palette, colors,
};
